import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Al cambiar de ruta, vuelve al inicio de la página.
 * Si hay hash (#sectores, #precios…), no fuerza scroll a 0:
 * la página destino se encarga del ancla.
 */
export default function ScrollToTop() {
	const { pathname, hash } = useLocation();

	useEffect(() => {
		if (hash) return;
		window.scrollTo(0, 0);
	}, [pathname, hash]);

	return null;
}
